import React from 'react'

import styles from './footer.module.css'


export default function Footer(props){    
    return(
            <div className={styles.foot}>
                --- footer is under construction... ---
            </div>
        )
}